(function () {
        var tabela = document.querySelector('[data-roczniki-tabela]');
        if (!tabela || !tabela.tBodies.length) { return; }
        var tbody = tabela.tBodies[0];
        var naglowki = tabela.querySelectorAll('th[data-sort]');
        var liczba = function (w, klucz) {
            var v = w.getAttribute('data-sort-' + klucz);
            return v === '' || v === null ? null : parseFloat(v);
        };
        Array.prototype.forEach.call(naglowki, function (th) {
            th.querySelector('button').addEventListener('click', function () {
                var klucz = th.getAttribute('data-sort');
                var malejaco = th.getAttribute('aria-sort') === 'ascending';
                var wiersze = Array.prototype.slice.call(tbody.rows);
                wiersze.sort(function (a, b) {
                    var pa = liczba(a, klucz), pb = liczba(b, klucz);
                    var rokA = liczba(a, 'rok'), rokB = liczba(b, 'rok');
                    // braki zawsze na koncu, remisy po roku rosnaco — niezaleznie od kierunku
                    if (pa === null && pb === null) { return rokA - rokB; }
                    if (pa === null) { return 1; }
                    if (pb === null) { return -1; }
                    return (malejaco ? pb - pa : pa - pb) || (rokA - rokB);
                });
                wiersze.forEach(function (w) { tbody.appendChild(w); });
                Array.prototype.forEach.call(naglowki, function (t) { t.setAttribute('aria-sort', 'none'); });
                th.setAttribute('aria-sort', malejaco ? 'descending' : 'ascending');
            });
        });
    })();
